import { EmbedVideoBlockSchema } from '@blocksuite/affine-model';
import { BlockNotionHtmlAdapterExtension } from '@blocksuite/affine-shared/adapters';

import { createEmbedBlockNotionHtmlAdapterMatcher } from '../../common/adapters/notion-html.js';
import { videoUrlRegex } from '../embed-video-model.js';

export const embedVideoBlockNotionHtmlAdapterMatcher =
  createEmbedBlockNotionHtmlAdapterMatcher(
    EmbedVideoBlockSchema.model.flavour,
    videoUrlRegex
  );

export const EmbedVideoBlockNotionHtmlAdapterExtension =
  BlockNotionHtmlAdapterExtension(embedVideoBlockNotionHtmlAdapterMatcher);
